import * as React from 'react';

import UIAsset from 'components/atoms/UIAsset';

import { GenderKeyType } from 'types/GenderKey';

export type GenderProps = {
	name: GenderKeyType;
	labelText: string;
};

export type GenderSelectorProps = {
	selectedGender?: GenderKeyType;
	genders?: GenderProps[];
	genderMeta?: Object;
	onGenderChange: (...args: any) => void;
};

export default class GenderSelector extends React.Component<GenderSelectorProps> {
	public static displayName = 'GenderSelector';

	public static defaultProps = {
		genders: [],
	};

	public static stateClasses = {
		inactive: 'state-m-gender-selector__gender--inactive',
		selected: 'state-m-gender-selector__gender--selected',
	};

	public getGenderImagePath(gender: GenderProps): string {
		return `/img/svg/anamnesis/gender-${gender.name === 'M' ? 'male' : 'female'}.svg`;
	}

	public renderGender = (gender: GenderProps) => {
		if (!gender) {
			return void 0;
		}

		const genderClasses = ['m-gender-selector__gender', `m-gender-selector__gender--${gender.name}`];

		if (this.props.selectedGender === gender.name) {
			genderClasses.push(GenderSelector.stateClasses.selected);
		} else {
			genderClasses.push(GenderSelector.stateClasses.inactive);
		}

		return (
			<li
				key={gender.name}
				className={genderClasses.join(' ')}
				onClick={() => {
					this.props.onGenderChange(gender.name);
				}}
			>
				<div className="m-gender-selector__bubble">
					<UIAsset
						className="m-gender-selector__image"
						src={this.getGenderImagePath(gender)}
						alt={gender.name}
					/>
				</div>
				<span className="m-gender-selector__text">{gender.labelText}</span>
			</li>
		);
	};

	public render() {
		const { genders } = this.props;

		return (
			<ol className="m-gender-selector">
				{Array.isArray(genders) && genders.length > 0 && genders.map(this.renderGender)}
			</ol>
		);
	}
}
